export const MSG_FIELDS_OPTIONS = {
	APPSCOPE: 'AppScope',
	ACUITY: 'Acuity',
	CLASSVALUATION: 'Class',
	CLASSORDERENTRY: 'ClassOrderEntry',
	CMPACUITY: 'CMPAcuity'
};

export const MSG_FIELDS_VALUE = {
	APPSCOPECHECK: {
		SCOPE: 'Select the job that the incoming order need to match',
		ACUITY: 'Select the product for the new order'
	},
	ACUITYCHECK: {
		SCOPE: 'Select the job name for the new order',
		ACUITY: 'Select the product that the incoming order needs to match'
	},
	DEFAULT: {
		SCOPE: 'Select the job for the new order',
		ACUITY: 'Select the product name for the new order'
	}
};

export const GSE_PREFERENCE = [
	{
		id: 'None',
		name: 'None'
	},
	{
		id: 'FREDDIE',
		name: 'Freddie Mac'
	},
	{
		id: 'FNMA',
		name: 'Fanni Mae'
	}
];

export const LINE_BUSINESS_LIST = [
	{
		id: 'Traditional',
		name: 'Traditional'
	},
	{
		id: 'Innovation',
		name: 'Innovation'
	},
	{
		id: 'Alternative',
		name: 'Alternative'
	}
];

export const ACUITY_TYPES_ORIGIN_LIST = [
	{
		id: 'acuity',
		name: 'Acuity'
	},
	{
		id: 'cmpacuity',
		name: 'Cmp Acuity'
	}
]

export const CREATION_TRIGGER = [
	{
		id: 'IncomingOrder',
		name: 'Incoming Provider Order'
	},
	{
		id: 'StatusChanged',
		name: 'Milestone Order Changes'
	}
];

export const SCOPE_ORDER_UPDATE_DOCUMENTS = 'SCOPE_ORDER_UPDATE_DOCUMENTS';

export const INTEGRATIONS = [ 'nexsys', 'xpanse', 'fnc', 'valutrust', 'integration' ];

export const LICENSE_SUBPRODUCT_LIST = [
	{
		id: 'Manage3DScan',
		name: 'Incoming Managed 3D Scan'
	},
	{
		id: 'VirtualInspection',
		name: 'Incoming Virtual Inspection'
	},
];

export const SIDE_CAR_ORIGINS = [
	{
		id: 'AppScope',
		name: 'AppScope'
	},
	{
		id: 'Class',
		name: 'ClassValuation'
	},
	{
		id: 'ClassOrderEntry',
		name: 'ClassOrderEntry'
	},
	{
		id: 'CMPAcuity',
		name: 'CMPAcuity'
	}
]